import {SET, UPDATE_EDITING, UPDATE_MODAL_OPEN} from './actions';

const initialState = {};
export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.screenBackground;
    case UPDATE_EDITING:
      return {
        ...state,
        _editing: action._editing,
      };
    case UPDATE_MODAL_OPEN:
      return {
        ...state,
        _modalOpen: action._modalOpen
      };

    default:
      return state;
  }
};
